/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CustomCheckBoxWithFormControl.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";

function CustomCheckBoxWithFormControl({
  value,
  onChange,
  label,
  error,
  disabled,
}) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          size="small"
          checked={value}
          onChange={onChange}
          disabled={disabled}
          sx={{
            color: "black",
            "&.Mui-checked": {
              color: "black",
            },
            "& .MuiSvgIcon-root": {
              fontWeight: "bold",
              width: 18,
              height: 18,
              overflow: "hidden",
              transition: "background-color 0.2s, color 0.2s",
            },
            // Hover for unchecked
            "&:hover .MuiSvgIcon-root": {
              backgroundColor: "#D6D6D6",
              boxShadow: "none",
            },
            // Hover for checked (deepen green)
            "&.Mui-checked:hover .MuiSvgIcon-root": {
              color: error ? "#941C13" : "black",
              backgroundColor: "transparent", // keep background inside border clean
            },
            ...(error && {
              "& .MuiSvgIcon-root": {
                color: "red",
              },
              "&:hover .MuiSvgIcon-root": {
                color: "darkred",
              },
            }),
            "&.Mui-disabled": {
              color: "grey",
              "& .MuiSvgIcon-root": {
                color: "grey",
              },
            },
          }}
        />
      }
      label={label}
      disabled={disabled}
    />
  );
}

export default CustomCheckBoxWithFormControl;
